import { useLayoutEffect, useEffect, type ReactNode } from "react";
import Hero from "../sections/Hero";
import Services from "../sections/Services";
import About from "../sections/About";
import Portfolio from "../sections/Portfolio";
import Testimonials from "../sections/Testimonials";
import Team from "../sections/Team";
import Contact from "../sections/Contact";
import Development from "../sections/Development";
import ItPageNav from "./it/ItPageNav";

const ItSection = ({
  id,
  tone,
  children,
  last = false,
}: {
  id: string;
  tone: "a" | "b";
  children: ReactNode;
  last?: boolean;
}) => (
  <div
    id={id}
    className={`it-snap-section it-snap-tone-${tone} w-full shrink-0 ${
      last ? "it-snap-no-snap snap-normal" : "snap-start snap-always"
    }`}
  >
    <div className="it-snap-inner">{children}</div>
  </div>
);

/** IT·R&D 공통: 동일 풀스냅 레이아웃 (경로별로 RndHome에서만 분기 가능) */
const AreaScrollHome = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    document.documentElement.classList.add("it-page-snap");
    return () => document.documentElement.classList.remove("it-page-snap");
  }, []);

  return (
    <>
      <ItPageNav />
      <ItSection id="home" tone="a">
        <Hero />
      </ItSection>
      <ItSection id="services" tone="b">
        <Services />
      </ItSection>
      <ItSection id="about" tone="a">
        <About />
      </ItSection>
      <ItSection id="development" tone="b">
        <Development />
      </ItSection>
      <ItSection id="portfolio" tone="a">
        <Portfolio />
      </ItSection>
      <ItSection id="testimonials" tone="b">
        <Testimonials />
      </ItSection>
      <ItSection id="team" tone="a">
        <Team />
      </ItSection>
      <ItSection id="contact" tone="b" last>
        <Contact />
      </ItSection>
    </>
  );
};

export default AreaScrollHome;
